import { useMutation } from '@tanstack/react-query';
import { requestAccountCleanup } from '@/services/api/account-cleanup';

export const useRequestAccountCleanup = () => useMutation({ mutationFn: requestAccountCleanup });
